// src/plugins/element-plus.js
import ElementPlus from "element-plus";
import "element-plus/dist/index.css"; // Import Element Plus styles
export default ElementPlus;
